import { Card, CardContent, Typography, Box } from "@mui/material";
import IntegrationService from "../../services/integrations/Integrations";
import { useEffect, useRef, useState } from "react";
import useDisplaySnackbar from "../../utils/useDisplaySnackbar";
import ProgressSpinner from "../Common/ProgressSpinner";
import "../../styles/settings.css";

const VideoGuides = () => {
  const [showSpinner, setShowSpinner] = useState<boolean>(false);
  const { showSnackbar } = useDisplaySnackbar();
  const [videoGuides, setVideoGuides] = useState<any[]>([]);
  const videoRefs = useRef<(HTMLVideoElement | null)[]>([]);

  const {
    isLoading: isVideoUrlsLoading,
    isFetching: isVideoUrlsFetching,
    isSuccess: isVideoUrlsSuccess,
    isError: isVideoUrlsError,
    error: videoUrlsError,
    data: videoUrlsData,
  } = IntegrationService.useGetVideoPresignedUrls(true);

  useEffect(() => {
    if (isVideoUrlsLoading || isVideoUrlsFetching) {
      setShowSpinner(true);
      return;
    }

    if (isVideoUrlsSuccess && videoUrlsData) {
      setShowSpinner(false);

      const formattedVideos =
        videoUrlsData?.data?.map(
          (item: { url: string; name: string }, index: number) => ({
            id: index,
            videoUrl: item?.url,
            title: item?.name,
          }),
        ) || [];

      setVideoGuides(formattedVideos);
    }

    if (isVideoUrlsError) {
      showSnackbar("error", videoUrlsError?.message || "Failed to load video.");
    }
  }, [
    isVideoUrlsLoading,
    isVideoUrlsFetching,
    isVideoUrlsSuccess,
    isVideoUrlsError,
    videoUrlsData,
    videoUrlsError,
  ]);

  const handleVideoPlay = (currentIndex: number) => {
    videoRefs.current.forEach((video, index) => {
      if (video && index !== currentIndex) {
        video.pause();
      }
    });
  };

  return (
    <Box className="video-container">
      <Box
        sx={{
          p: { xs: 2, sm: 3 },
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        <Box className="video-guides-grid"
          sx={{
            gridTemplateColumns: {
              xs: "1fr",
              sm: "repeat(2, minmax(0, 1fr))",
              lg: "repeat(3, minmax(0, 1fr))",
            },
            gap: { xs: 2, sm: 2.5, lg: 3 },
          }}
        >
          {videoGuides.map((video) => (
            <Card className="video-card-container" key={video.id}>
              <Box className="video-box">
                <video
                  ref={(el) => (videoRefs.current[video.id] = el)}
                  width="100%"
                  height="100%"
                  controls
                  preload="metadata"
                  controlsList="nodownload"
                  disablePictureInPicture
                  onContextMenu={(e) => e.preventDefault()}
                  onPlay={() => handleVideoPlay(video.id)}
                  style={{
                    objectFit: "contain",
                    display: "block",
                    backgroundColor: "#000",
                  }}
                >
                  <source src={video.videoUrl} />
                  Your browser does not support the video tag.
                </video>
              </Box>

              <CardContent className="video-card-content">
                <Typography
                  variant="subtitle1"
                  fontWeight={600}
                  textAlign="center"
                  sx={{ wordBreak: "break-word" }}
                >
                  {video.title}
                </Typography>
              </CardContent>
            </Card>
          ))}
        </Box>
      </Box>
      <ProgressSpinner showSpinner={showSpinner} />
    </Box>
  );
};

export default VideoGuides;